function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#3C4E5A",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M8.571 16.381a7.952 7.952 0 1 1 5.883-13.304c-.184.217-.413.537-.689.959a6.857 6.857 0 1 0 1.362 2.462c.232-.47.587-.585 1.065-.347a7.952 7.952 0 0 1-7.62 10.23z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.722.896l.373 3.114a.4.4 0 0 1-.403.448l-3.153-.044a.4.4 0 0 1-.291-.668l2.78-3.07a.4.4 0 0 1 .694.22zM10.257 10.477l-2.17-1.195-.02-.003a.421.421 0 0 1-.345-.414v-.008l.047-2.631a.376.376 0 0 1 .751 0l.036 2.13 2.166 1.315a.466.466 0 0 1-.465.806z"
}));

var SvgHistory = function SvgHistory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHistory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/history.6daa926e.svg";
export { ForwardRef as ReactComponent };